import axios from './index'

import prefix_ms from './prefix'

/** 获取精选文章列表 */
export const getRecommendArticleList = ({ pageIndex, pageSize }) => {
    return axios.request({
        url: `${prefix_ms}/mixtureArticle/isFine/list`,
        method: 'get',
        params: { pageIndex, pageSize }
    })
}


/** 获取考试文章列表 */
export const getExamArticleList = ({ examLabelId, pageIndex, pageSize }) => {
    return axios.request({
        url: `${prefix_ms}/mixtureArticle/examLabel/list`,
        method: 'get',
        params: { examLabelId, pageIndex, pageSize }
    })
}

/** 获取考试标签列表 */
export const getExamLableList = () => {
    return axios.request({
        url: `${prefix_ms}/examLabel/list`,
        method: 'get',
    })
}

/** 今日文章 */
export const getTodayArticle = () => {
    return axios.request({
        url: `${prefix_ms}/article/today`,
        method: 'get',
    })
}

/** 获取分类文章列表 */
export const getArticleList = ({ extensionType, pageIndex, pageSize }) => {
    return axios.request({
        url: `${prefix_ms}/article/list`,
        method: 'get',
        params: { extensionType, pageIndex, pageSize }

    })
}
/** 获取合集列表 */
export const getCollectionList = ({ collectionId, pageIndex, pageSize }) => {
    return axios.request({
        url: `${prefix_ms}/collection/articles`,
        method: 'get',
        params: { collectionId, pageIndex, pageSize }

    })
}
/** 获取合集描述 */
export const getCollectionDetail = ({ collectionId }) => {
    return axios.request({
        url: `${prefix_ms}/collection/detail`,
        method: 'get',
        params: { collectionId }

    })
}


/** 用户获取文章详情 */
export const getArticleDetail = ({ articleId }) => {
    return axios.request({
        url: `${prefix_ms}/userArticle/article`,
        method: 'get',
        params: { articleId }
    })
}

/** 获取文章重点单词 */
export const getPrimaryWords = ({ articleId }) => {
    return axios.request({
        url: `${prefix_ms}/articlePrimaryWords/list`,
        method: 'get',
        params: { articleId }
    })
}

/** 获取文章推荐内容id */
export const getRecommendContent = ({articleId}) => {
    return axios.request({
        url: `${prefix_ms}/userArticle/content/recommend`,
        method: 'get',
        params: { articleId }
    })
}

export const getUserArticleContent = ({contentId}) => {
    return axios.request({
        url: `${prefix_ms}/userArticle/content`,
        method: 'get',
        params: { contentId }
    })
}

export const getArticleLevels = ({articleId}) => {
    return axios.request({
        url: `${prefix_ms}/article/content/difficulty/list`,
        method: 'get',
        params: { articleId }
    })
}


export const getArticleWordBook = ({articleId}) => {
    return axios.request({
        url: `${prefix_ms}/userNewWord/article/list`,
        method: 'get',
        params: { articleId }
    })
}

export const getArticleQuiz = ({contentId}) => {
    return axios.request({
        url: `${prefix_ms}/article/content/question/list`,
        method: 'get',
        params: { contentId }
    })
}

export const postAnswers = ({answers,contentId,duration}) => {
    return axios.request({
        url: `${prefix_ms}/userArticle/multipleChoice/report/all`,
        method: 'post',
        data: {answers,contentId,duration}
    })
}

export const getSimilarArticle = ({articleId})=>{
    return axios.request({
        url: `${prefix_ms}/userArticle/similar`,
        method: 'get',
        params: { articleId }
    })
}

export const getDailyShareInfo = (data)=>{
    return axios.request({
        url: `${prefix_ms}/shareReadRecord/share/getInfo`,
        method: 'post',
        data: data
    })
}

///v2/user/whetherHaveFreeMember 校验用户是否有免费会员未消耗
export const whetherHaveFreeMember = ()=>{
    return axios.request({
        url: `${prefix_ms}/user/whetherHaveFreeMember`,
        method: 'get'
    })
}

///v2/user/freeMember/consume 确认消耗免费会员
export const consume3Vip = ()=>{
    return axios.request({
        url: `${prefix_ms}/user/freeMember/consume`,
        method: 'post'
    })
}

// export const getArticleContent = ()
// GET
// /v2/userArticle/content
// 用户获取文章的内容
// GET
// /v2/userArticle/content/recommend
// 获取推荐文章内容(根据上次阅读蓝思值)
// POST
// /v2/userArticle/multipleChoice/report/all
// 选择题回答上报
// GET
// /v2/userArticle/read/detail
// 获取某篇文章阅读详情
// GET
// /v2/userArticle/similar
// 获取类似文章
// GET
// /v2/userArticle/someday
// 获取某日阅读文章记录


//////////////////
// WEBPACK FOOTER
// ./app/api/article.js
// module id = null
// module chunks = 